import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import HamburgerMenu from '../../Components/HamburgerMenu/HamburgerMenu';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DocumentService from '../../Services/documents.service';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import UserService from '../../Services/user.service';
import './SortCodeReport.css';
import backIcon from '../../assests/images/left-arrow.png';
import EnumsService from '../../Services/enums.service';
import ClientDocumentCountService from '../../Services/ClientDocumentCount.service';
import { ToastContainer, toast } from "react-toastify";

import { Button } from 'primereact/button';
import ClientService from '../../Services/client.service';
import NoDocumentsPdf from "../../assests/pdf/NoDocument.pdf";
import classNames from 'classnames';
import { Edit as EditIcon } from '@mui/icons-material';
import CustomDeleteConfirmationModal from '../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal';
import EditModal from '../../Components/EditModal/EditModal';
import CircularProgress, {
    circularProgressClasses,
} from '@mui/material/CircularProgress';
import FilterMonthYearPicker from '../../Components/Widgets/CustomDates/FilterMonthYearPicker/FilterMonthYearPicker.jsx';
import headerStyles from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/HeaderToolbar.module.scss';
import dayjs, { Dayjs } from 'dayjs';
import Constants from '../../assests/Constants/constants';
import useCaseSystemAccountSettings from '../../hooks/useCaseSystemAccountSettings';
import PuffLoader from "react-spinners/PuffLoader";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { beautifyNumber } from '../../Utils/FormatNumber';
import {
    Modal,
    Typography,
    colors,
    Dialog,
    DialogTitle,
    ListItem,
    TextField,
    FormControlLabel,
    Box,
    Checkbox,
    ToggleButton,
    ToggleButtonGroup,
} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import AutocompleteSelectFilter from '../../Components/Widgets/AutocompleteSelectFilter/AutocompleteSelectFilter';
import { setYear } from 'date-fns';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails';
import SortCodeReportTable from '../../Components/SortCodeReport/SubComponents/SortCodeReportTable';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext';
import { validateDocumentBeforeProcessing, validatePaymentAcceptanceItems } from '../../Utils/documentValidation'
import ChooseAsset from '../../Components/Widgets/ChooseAsset/ChooseAsset';
import AssetService from '../../Services/assets.service';
import AddAssetGroup from '../../Components/Assets/SubComponents/AddAssetGroup';
import AssetFoundDialog from '../../Components/Widgets/AssetFoundDialog/AssetFoundDialog';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext';
import NavigationButton from '../../Components/NavigationButton/NavigationButton.jsx';

import { setRange } from '../../store/reducers/reportPeriodSlice';
import '../Document/Document.scss';


registerLocale('en-GB', {
    ...enGB,
    localize: {
        ...enGB.localize,
        month: n => n + 1, // Display months as numbers starting from 1
    },
    formatLong: {
        ...enGB.formatLong,
        date: () => 'MM/yyyy', // Date format when the picker is not showing
    },
});

setDefaultLocale('en-GB'); // Set the default locale to use it

// Helper function to adjust date to Israel time zone (UTC+2)
const adjustToIsraelTime = (date) => {
    const israelTimeOffset = 2 * 3600 * 1000; // 2 hours in milliseconds
    return new Date(date.getTime() + israelTimeOffset);
};

// Helper function to get the start of the year in Israel time
const getStartOfYear = (date) => {
    const startOfYear = new Date(date.getFullYear(), 0, 1); // Jan 1st of the given year
    return adjustToIsraelTime(startOfYear);
};

// Helper function to get the current month in Israel time
const getCurrentMonth = (date) => {
    const currentMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0); // Last day of the current month
    return adjustToIsraelTime(currentMonth);
};

function SortCodeReport() {
    const navigate = useNavigate();
    const { i18n, t } = useTranslation();
    const direction = i18n.dir();
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');
    // const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const sortCodeFetchGenerationRef = useRef(0);
    const location = useLocation();
    const navState = location.state || {};     // <— keep one reference
    const [segmentationFilter] = useState(() => navState.segmentationFilter ?? null);

    /* ----- FIRST group of state hooks depends on navState ----- */
    const [client, setClient] = useState(navState.client || null);
    const { settings: caseSystemSettings } = useCaseSystemAccountSettings(client?.caseId, token);
    const [type, setType] = useState(navState.type || '');

    const [startDate, setStartDate] = useState(
        navState.startDate ? new Date(navState.startDate) : null
    );
    const [endDate, setEndDate] = useState(
        navState.endDate ? new Date(navState.endDate) : null
    );

    // const [isMonthly,      setIsMonthly]      = useState(
    // typeof navState.isMonthly === 'boolean' ? navState.isMonthly : true
    // );
    const [startYearDate, setStartYearDate] = useState(
        navState.startYearDate ? new Date(navState.startYearDate) : new Date()
    );
    const [endYearDate, setEndYearDate] = useState(
        navState.endYearDate ? new Date(navState.endYearDate) : new Date()
    );


    const [isDataFetched, setIsDataFetched] = useState(false);
    const [columns, setColumns] = useState([]);
    const [nodes, setNodes] = useState([]);
    const [footerTotals, setFooterTotals] = useState({});
    const [specialNode, setSpecialNode] = useState(null);
    const [expandedRows, setExpandedRows] = useState({});
    const [isExpandedToggle, setIsExpandedToggle] = useState(false);
    const [sortCodeName, setSortCodeName] = useState('');
    const [sortCodeGroup, setSortCodeGroup] = useState('');
    const [responseData, setResponseData] = useState([]);
    const [sortCodeId, setSortCodeId] = useState('');
    // Sort code chosen explicitly (navigation state or the picker below). It wins over
    // sortCodeName, which cannot identify a single sort code when names are duplicated.
    const [selectedSortCodeId, setSelectedSortCodeId] = useState(
        navState.sortCodeId != null ? String(navState.sortCodeId) : ''
    );
    const [isPurchaseOfEquipment, setIsPurchaseOfEquipment] = useState('');
    const { goBack } = useContext(NavHistoryContext);

    //for item edit
    const [numberOfRowsPerPage, setNumberOfRowsPerPage] = useState(1000);
    const [isFirstUserFetched, setIsFirstUserFetched] = useState(false);
    const [clientItems, setClientItems] = useState([]);
    const [creditAccountOptions, setCreditAccountOptions] = useState([]);
    const [debitAccountOptions, setDebitAccountOptions] = useState([]);
    const [editedItem, setEditedItem] = useState({});
    const [statusCheck, setStatusCheck] = useState(false);
    const [editingRow, setEditingRow] = useState(null);
    const [editedAddAccountCard, setEditedAddAccountCard] = useState(false);
    const [accountCardOptions, setAccountCardOptions] = useState([]);
    const [formattedPalCodeOptions, setFormattedPalCodeOptions] = useState([]);

    const [accountCardEditDownloadOptions, setAccountCardEditDownloadOptions] = useState([]);
    const [originalAccountCardId, setOriginalAccountCardId] = useState('');
    const [isClosedReportingMonth, setIsClosedReportingMonth] = useState(false);
    const [sortCodeIdOptions, setSortCodeIdOptions] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: 'uploadNumber', direction: 'descending', type: 'number' });
    const [invoiceSignature, setInvoiceSignature] = useState('');
    const [currentIndex, setCurrentIndex] = useState(-1);
    const [fade, setFade] = useState(false);
    const [editedPopupItem, setEditedPopupItem] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [itemToDelete, setItemToDelete] = useState({});
    const { setMenuProps } = useHamburgerMenu();
    const dispatch = useDispatch();

    const {
        isMonthly,

    } = useSelector((state) => state.reportPeriodSlice);
    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);

    const [isRange, setIsRange] = useState(() => {
        const storedIsRange = localStorage.getItem('IsRange');
        return storedIsRange === "true";
    });;

    // true = filter by document date; false = filter by register month date
    const [filterByDocumentDate, setFilterByDocumentDate] = useState(() => {
        const savedValue = localStorage.getItem('SortCodeReport-filterByDocumentDate');
        return savedValue === null ? false : JSON.parse(savedValue);
    });

    useEffect(() => {
        localStorage.setItem('SortCodeReport-filterByDocumentDate', JSON.stringify(filterByDocumentDate));
    }, [filterByDocumentDate]);

    const handleCancel = () => {
        setEditingRow(null);
        setEditedItem({});
        setEditedAddAccountCard(false);
    };

    const fetchDocumentsNotification = async (client, token) => {
        const documentCounts = await ClientDocumentCountService.getClientDocumentCountByCaseId(client.caseId, token);

        // Enrich clients with their total document counts
        const enrichedClient = {
            ...client,
            totalCounts: documentCounts.totalCounts || 0, // Default to 0 if no matching count is found
            documentCounts: documentCounts.documentCounts || {},
            documentIds: documentCounts.documentIds || {},
        };
        setInvoiceSignature(enrichedClient.signature);
        setClient(enrichedClient);
    }
    const handleCloseEditAddNewAccountCardDocument = () => {
        setEditedItem({ ...editedItem, accountCodeName: '', accountCodeId: '' })
        setEditedAddAccountCard(false);
    };

    useEffect(() => {
        if (currentIndex != -1) {
            setFade(true);
            const timer = setTimeout(() => setFade(false), 500);
            return () => clearTimeout(timer);
        }
    }, [currentIndex]);
    const handleEditAddAccountChange = (selectedOption, field) => {

        if (field === 'AccountCodeId') {
            type === 'Incomes' ? setEditedItem({ ...editedItem, accountCodeId: selectedOption, debitAccount: selectedOption }) : setEditedItem({ ...editedItem, accountCodeId: selectedOption, creditAccount: selectedOption });
        }
        else if (field === 'AccountCodeName') {
            setEditedItem({ ...editedItem, accountCodeName: selectedOption })
        }
        else {
            setEditedItem({ ...editedItem, accountCaseId: selectedOption })

        }
    };

    const updateAccountFields = (newValue, accountType) => {


        const isIncomesDebit = editedItem.docType === 'Incomes' && accountType === 'debitAccount';
        const isExpensesCredit = editedItem.docType === 'Expenses' && accountType === 'creditAccount';

        const updatedFields = {
            accountCodeId: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.cardId : '') : '',
            accountCodeName: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.name : '') : '',
            accountCaseId: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.accountCaseId : '') : '',
        };

        // Update the edited item with the new fields
        setEditedItem((prev) => ({
            ...prev,
            [accountType]: newValue ? newValue.cardId : '',
            ...(isIncomesDebit || isExpensesCredit ? updatedFields : {}),
        }));
    };


    const [showAssetFoundDialog, setShowAssetFoundDialog] = useState(false);
    const [foundAsset, setFoundAsset] = useState(null);
    const fetchEnumsNoParams = async () => {
        await fetchEnums(user, token, client);
    }

    const isPurchaseOfEquipment2 = (item) => {

        if (!item) return false; // If the item is not found, allow processing
        const sortCode = sortCodeIdOptions.find((option) => option.sortCodeId === item.sortCodeId);
        if (!sortCode) return false; // If the sort code is not found, allow processing


        return Boolean(Constants.depreciationAssetSortCodeType[sortCode.sortCodeVatType]);
    };



    const handleChange = (field, value) => {

        const updatedValue = value;

        if (field === 'sortCodeId') {
            let depreciation = false;

            if (isDepreciationDocument(editedItem, value)) {
                depreciation = true;
                setItemToAddToAsset(editedItem.id);
                setShowChooseAsset(true);

            }

            if (isPurchaseOfEquipment2(editedItem) && !depreciation) {
                if (assets) {
                    const assetFound = assets.find(
                        (asset) => asset.expenseId === editedItem.id || asset.journalEntryId === editedItem.id
                    );
                    if (assetFound) {
                        setFoundAsset(assetFound);
                        setShowAssetFoundDialog(true);
                    }
                }
            }



            if (!value || !sortCodeIdOptions.some((option) => option.sortCodeId === value)) {
                // Set default values for the empty state
                setEditedItem({
                    ...editedItem,
                    vat: 100, // Default VAT
                    [field]: '',
                });
                return; // Exit early since there's no valid sortCodeId
            }

            const name = sortCodeIdOptions.find(
                (option) => option.sortCodeId === value
            )?.sortCodeName || ''

            // Extract the name without the parentheses
            const nameWithoutParentheses = name.replace(/\s*\(.*?\)\s*/, '').trim();

            // Check for a number within parentheses
            const match = name.match(/\((\d+)%?/);
            let customVat = match ? parseInt(match[1], 10) : null;


            const sortCode = sortCodeIdOptions.filter(sc => sc.sortCodeId === updatedValue)[0];

            // Determine the VAT based on the name without parentheses
            const newVat = sortCode?.vat ?? 100;
            const accountCard = accountCardOptions.find(
                (item) => item.cardId === (type === 'Incomes' ? sortCode.debitAccount : sortCode.creditAccount)
            );
            setEditedItem({
                ...editedItem,
                vat: newVat,
                [field]: updatedValue,
                [type === 'Incomes' ? 'debitAccount' : 'creditAccount']:
                    editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount']
                        ? (accountCard ? accountCard.cardId : editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount'])
                        : editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount'],
                accountCodeName: accountCard ? accountCard.name : editedItem.accountCodeName,
                accountCodeId: accountCard ? accountCard.cardId : editedItem.accountCodeId,
                accountCaseId: accountCard ? accountCard.accountCaseId : editedItem.accountCaseId,
            });

        }
        else if (field === 'creditAccount' || field === 'debitAccount') {

            // Use the helper function to update account fields for credit or debit account
            const newValue = accountCardOptions.find(option => option.cardId === updatedValue) || null;
            updateAccountFields(newValue, field);
        }
        else {
            // For fields other than sortCodeId, just update the edited item
            setEditedItem({
                ...editedItem,
                [field]: updatedValue,
            });
        }
    };

    const handleDateChange = (e, field) => {
        setEditedItem({ ...editedItem, [field]: e });
    };

    const handleReopenEdit = async (item, index) => {
        ;

        await fetchEnums(user, token, client);
        setItemToDelete({ id: item.id, type: item.docType });
        setEditingRow(item.id);
        setEditedItem({ ...item }); // create a copy of the item for editing
        setEditedPopupItem(true);
        setStatusCheck(item['t-processed'] === 'מסמך טופל');
        // handleEdit(updatedResponseData);
    };


    //choose asset
    const [saleEquipment, setSaleEquipment] = useState(false);
    const [dateForAsset, setDateForAsset] = useState(new Date().toISOString());
    const [typeToPassToChoose, setTypeToPassToChoose] = useState('');
    const [clickedAsset, setClickedAsset] = useState(null);

    const isDepreciationDocument = (editedItem, sortCodeId) => {
        const item = editedItem;
        const itemId = editedItem.id;
        if (!item) return false; // If the item is not found, allow processing
        setItemForAssets(item);
        setDateForAsset(item.documentDate);
        const sortCode = sortCodeIdOptions.find((option) => option.sortCodeId === sortCodeId);
        if (!sortCode) return false; // If the sort code is not found, allow processing

        const isItemUsedInAssets = assets.some(
            (asset) => asset.expenseId === itemId || asset.journalEntryId === itemId
        );


        const name = sortCode.sortCodeName?.trim().replace(/\s+/g, ' ') || "";
        const saleEquipmentRegex = /(מכירה|מכירת).*ציוד|ציוד.*(מכירה|מכירת)/;
        if (sortCode.sortCodeId === caseSystemSettings.fixedAssetSaleSortCode || saleEquipmentRegex.test(name)) {

            setSaleEquipment(true);
            return true;
        }

        setSaleEquipment(false);
        return Boolean(Constants.depreciationAssetSortCodeType[sortCode.sortCodeVatType]);
    };

    const [showChooseAsset, setShowChooseAsset] = useState(false);
    const [itemToAddToAsset, setItemToAddToAsset] = useState('');
    const [itemForAssets, setItemForAssets] = useState({});


    const handleAssetClicked = (asset, item) => {
        setItemToAddToAsset(item.id);
        setItemForAssets(item)
        setClickedAsset(asset);
        setShowChooseAsset(true);
    }



    const handleAssetClose = () => {
        setShowChooseAsset(false);
        setClickedAsset(null);
    }



    const handleAccountChange = (selectedOption, field) => {
        if (field === 'debitAccount' || field === 'creditAccount') {
            const accountCardEditDownload = accountCardEditDownloadOptions.find(option => option.cardId === selectedOption.value);
            const name = accountCardEditDownload?.name;
            const accountCaseId = accountCardEditDownload?.accountCaseId;
            if (selectedOption.value < 0) {

                setOriginalAccountCardId(editedItem.cardId)
            }
            if (editedItem.docType === 'Incomes') {
                setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: selectedOption.value, debitAccount: selectedOption.value, accountCaseId: accountCaseId })
            }
            else if (editedItem.docType === 'Expenses') {
                setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: selectedOption.value, creditAccount: selectedOption.value, accountCaseId: accountCaseId });
            }
            else if (editedItem.docType === 'JournalEntries') {
                setEditedItem({
                    ...editedItem,
                    [field]: selectedOption.value
                });
            }
        } else if (field === 'accountCodeId') {
            if (selectedOption.value1 === 'AddItem') {
                setEditedAddAccountCard(true);
                setEditedItem({ ...editedItem, accountCodeName: '', accountCodeId: '', accountCaseId: '' })
            }
            else {
                const accountCardEdit = accountCardEditDownloadOptions.find(option =>
                    option.cardId === selectedOption.value
                );
                const name = accountCardEdit?.name;
                const accountCaseId = accountCardEdit?.accountCaseId;
                const cardId = selectedOption.value;
                if (editedItem.docType === 'Incomes') {
                    setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, debitAccount: cardId, accountCaseId: accountCaseId })
                }
                else if (editedItem.docType === 'Expenses') {
                    setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, creditAccount: cardId, accountCaseId: accountCaseId });
                }
                else if (editedItem.docType === 'JournalEntries') {
                    setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, accountCaseId: accountCaseId })
                }
            }
        }
    };
    const CustomInput1 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="document-custom-input1" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const CustomInput2 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="edit-custom-input" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const setReportingMonthDate = async (selectedDate, field) => {
        if (!selectedDate) {
            return;
        }
        const newDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), 10));
        const response1 = await ClientService.CheckIfMonthClosed(client.caseId, newDate, token);
        if (response1.ok) {
            const isClosedReportingMonth = await response1.json();
            if (isClosedReportingMonth) {
                toast.info(t('MonthReportAlreadyClosedTryAgain'));
                return
            }
            else {
                setEditedItem({ ...editedItem, [field]: newDate });
            }
        }
    }
    const handleRadioChange = async (e, options = {}) => {
        if (e.target.value?.toString() === 'done' && !options?.validationAlreadyDone) {

            const isValid = await validateDocumentBeforeProcessing(editedItem, t, client, options?.forceProcess === true);
            if (!isValid) return;
        }

        if (e.target.value?.toString() === 'done') {
            setStatusCheck(true);
        }
        else if (e.target.value?.toString() === 'notDone') {
            setStatusCheck(false);
        }

        setEditedItem({ ...editedItem, status: e.target.value });
    };
    const handleVatRadioChange = (e) => {
        setEditedItem({ ...editedItem, ["vat"]: parseFloat(e.target.value) });
    };
    const handleUpdate = async (itemId) => {
        setLoading(true);
        let finalResponse = null; // This will hold the final response, whether from Incomes or Expenses
        // setEditedPopupItem(false);
        let documentUrl = editedItem.documentUrl;

        try {
            delete editedItem.documentUrl; // Ensure the document URL is not part of the update if present


            if (editedItem.docType === 'Incomes') {
                finalResponse = await DocumentService.UpdateDocument("Incomes", token, editedItem);
            }
            else if (editedItem.docType === 'Expenses') {
                finalResponse = await DocumentService.UpdateDocument("Expenses", token, editedItem);
            }
            else if (editedItem.docType === 'JournalEntries') {
                finalResponse = await DocumentService.UpdateDocument("JournalEntries", token, editedItem);
            }
            setTypeToPassToChoose(editedItem.docType);

            // Proceed with additional actions only if finalResponse is successful
            if (finalResponse && finalResponse.ok) {
                // Reassign documentUrl back to editedItem after successful update
                editedItem.documentUrl = documentUrl;

                if (editedItem.status === 'done') {
                    if (isDepreciationDocument(editedItem)) {
                        setItemToAddToAsset(editedItem.id);
                        setShowChooseAsset(true);

                    }
                    await handleDoneClick(editedItem.id, editedItem.docType);
                    handleSortChange('id', 'newest', 'descending');
                } else if (editedItem.status === 'notDone') {
                    await handleNotDoneClick(editedItem.id, editedItem.docType);
                }

                if (editedAddAccountCard) {
                    await handleAccountCardSave(editedItem.accountCodeId, editedItem.accountCodeName, editedItem.accountCaseId);
                    await fetchEnums(user, token, client);
                }

                // await fetchSortCodeDetails(new Date(startDate), new Date(endDate));


                // Show success toast
                toast.success(t("documentUpdateSuccess"));
            } else {
                // Reassign documentUrl back to editedItem even on error to maintain state
                editedItem.documentUrl = documentUrl;

                const errorText = await finalResponse.text();
                toast.error(t("documentUpdateError") + ": " + errorText);
            }
        } catch (error) {
            // This block catches unexpected errors such as network issues, not HTTP errors which are handled above
            console.error("Unexpected error occurred: ", error);
            toast.error(t("documentUpdateError"));
            // Reassign documentUrl back to editedItem on catch error to maintain state
            editedItem.documentUrl = documentUrl;
        }
        // setEditedItem({});
        // setEditingRow(null);
        await fetchSortCodeDetails(startDate, endDate);
        setEditedAddAccountCard(false);
        setLoading(false); // Always stop loading at the end of the operation
    };

    const handleDoneClick = async (itemId, docType) => {
        setLoading(true);
        try {
            const response = await ClientDocumentCountService.removeDocumentByTypeAndId(client.caseId, client.accountantId, docType, itemId, token);
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLoading(false);
    };
    const handleSortChange = (key, type, Direction = '') => {
        let direction = Direction || 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction, type });
    };
    const handleNotDoneClick = async (itemId, docType) => {
        setLoading(true);
        try {
            const response = await ClientDocumentCountService.addDocumentByTypeAndId(client.caseId, client.accountantId, docType, itemId, token)
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLoading(false);
    };
    const handleAccountCardSave = async (AccountCodeId, AccountCodeName, AccountCaseId) => {
        const response2 = await EnumsService.AddAccountCard(client.caseId, AccountCodeId, AccountCodeName, AccountCaseId, token);
        if (!response2.ok) {
            throw new Error(`HTTP error! status: ${response2.status}`);
        }
    };

    const [assets, setAssets] = useState([]);
    const [showAddGroupModal, setShowAddGroupModal] = useState(false);
    const [assetGroups, setAssetGroups] = useState([]);

    const handleOpenGroudAdd = () => {
        setShowAddGroupModal(true);
    }



    //FetchEnums
    const fetchEnums = async (user, token, client) => {
        setLoading(true);
        try {
            // Initiate all fetch requests in parallel
            const [
                sortCodeGroupResponse,
                codeIdResponse,
                accountsResponse,
                palCodesResponse
            ] = await Promise.all([
                EnumsService.GetSortCodesGroupByAccountantId(client.accountantId, token),
                EnumsService.GetSortCodesByAccountantId(client.accountantId, token),
                EnumsService.GetAccountCardsByCaseId(client.caseId, token),
                EnumsService.GetPalCodesByAccountantId(client.accountantId, token)
            ]);

            // Process sortCodeGroupOptions if response is okay
            const sortCodeGroupData = await sortCodeGroupResponse.json();
            setSortCodeGroup(sortCodeGroupData);

            // Process sortCodeIdOptions if response is okay
            if (codeIdResponse.ok) {
                const codeIdData = await codeIdResponse.json();
                setSortCodeIdOptions(codeIdData); // Assuming codeIdData is already in the correct format
            }

            const assetGroupResponse = await AssetService.GetAllAssetGroups(client?.caseId, token);
            if (assetGroupResponse.success) {
                setAssetGroups(assetGroupResponse.data);
            } else {
                toast.error(t('FailedToFetchAssets'));
            }

            // Process account options if response is okay
            if (accountsResponse.ok) {
                const accountsData = await accountsResponse.json();
                setCreditAccountOptions(accountsData);
                setDebitAccountOptions(accountsData); // Assuming both options are the same
                setAccountCardEditDownloadOptions(accountsData);
                const accountCardOptions = [{ name: t('AddAccountCard'), value1: 'AddItem' }, ...accountsData];
                setAccountCardOptions(accountCardOptions);
            }

            // Process palCodes if response is okay
            if (palCodesResponse.ok) {
                const palCodesData = await palCodesResponse.json();
                const formattedPalCodes = palCodesData.map(palCode => ({
                    label: palCode.palCodeId,
                    value: palCode.palCodeId
                }));
                setFormattedPalCodeOptions(formattedPalCodes);
            }

            const assetResponse = await AssetService.GetAllAssets(client?.caseId, token);
            if (assetResponse.success) {
                setAssets(assetResponse.data);
            } else {
                toast.error(t('FailedToFetchAssets'));
            }

            setIsDataFetched(true);
            // toast.success(t('enumFetchSuccess'));
        } catch (error) {
            console.error("Error fetching enum data:", error);
            toast.error(`${t("Error fetching enum data")}: ${error}`);
        } finally {
            setLoading(false);
        }
    };


    const handleRangeChange = (monthly) => {
        dispatch(setRange({ isMonthly: monthly }));
    };

    /* ------------------------- sort code picker ------------------------- */

    // The picker shows the explicit selection, or the id the last name lookup resolved to.
    const displayedSortCodeId = selectedSortCodeId || (sortCodeId ? String(sortCodeId) : '');

    /**
     * Options for the sort code picker. Labels are "{id} - {name}" so duplicated
     * names stay distinguishable. When the report was opened for a sort code that is
     * not in the accountant's list (e.g. the "-1" bucket of documents without a sort
     * code), a synthetic option keeps the current selection visible.
     */
    const sortCodePickerOptions = useMemo(() => {
        const options = (sortCodeIdOptions ?? []).map((sc) => ({
            value: String(sc.sortCodeId),
            label: sc.sortCodeName ? `${sc.sortCodeId} - ${sc.sortCodeName}` : String(sc.sortCodeId),
        }));

        if (
            displayedSortCodeId &&
            !options.some((option) => option.value === displayedSortCodeId)
        ) {
            options.unshift({
                value: displayedSortCodeId,
                label: sortCodeName || displayedSortCodeId,
            });
        }

        return options;
    }, [sortCodeIdOptions, displayedSortCodeId, sortCodeName]);

    const selectedSortCodeOption = useMemo(
        () =>
            sortCodePickerOptions.find((option) => option.value === displayedSortCodeId) ?? null,
        [sortCodePickerOptions, displayedSortCodeId],
    );

    const findSortCodeById = (id) =>
        (sortCodeIdOptions ?? []).find((sc) => String(sc.sortCodeId) === String(id)) ?? null;

    const handleSortCodePicked = (option) => {
        if (!option) {
            // Invalidate any in-flight fetch so it cannot repopulate the table after clear.
            sortCodeFetchGenerationRef.current += 1;
            setSelectedSortCodeId('');
            setSortCodeId('');
            setSortCodeName('');
            setNodes([]);
            setResponseData([]);
            setFooterTotals({});
            setColumns([]);
            setIsPurchaseOfEquipment(false);
            setLoading(false);
            return;
        }

        const sortCode = findSortCodeById(option.value);
        setSelectedSortCodeId(String(option.value));
        setSortCodeName(sortCode?.sortCodeName ?? option.label ?? '');
    };

    // Equipment purchases get an extra shortcut to the assets page. Derived from the
    // selection so it stays correct even when the sort code list loads after the report.
    useEffect(() => {
        if (!displayedSortCodeId) return;

        const sortCode = findSortCodeById(displayedSortCodeId);
        if (!sortCode) return;

        setIsPurchaseOfEquipment(
            sortCode.sortCodeVatType === Constants.SortCodeVatTypeValue.VatEquipment
        );
    }, [displayedSortCodeId, sortCodeIdOptions]);

    /* One canonical place to watch the value */



 


  

    const toUtcMonthStart = (year, monthIndex) =>
        new Date(Date.UTC(year, monthIndex, 1, 0, 0, 0, 0));

    const toUtcMonthEnd = (year, monthIndex) =>
        new Date(Date.UTC(year, monthIndex + 1, 0, 23, 59, 59, 999));

    const handleStartDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        if (Number.isNaN(newDate.getTime())) return;

        const currentStart = startDate ? new Date(startDate) : newDate;
        let updatedDate;

        if (type === 'year') {
            updatedDate = toUtcMonthStart(newDate.getUTCFullYear(), currentStart.getUTCMonth());
        } else if (type === 'month') {
            // CustomMonthYearIndividualDatePicker emits 01-MM UTC; keep that day
            updatedDate = toUtcMonthStart(
                newDate.getUTCFullYear(),
                newDate.getUTCMonth()
            );
        } else {
            return;
        }

        if (isMonthly) {
            setStartDate(updatedDate);
        } else {
            setStartYearDate(toUtcMonthStart(newDate.getUTCFullYear(), 0));
        }
    };

    const handleEndDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        if (Number.isNaN(newDate.getTime())) return;

        const currentEnd = endDate ? new Date(endDate) : newDate;
        let updatedDate;

        if (type === 'year') {
            updatedDate = toUtcMonthEnd(newDate.getUTCFullYear(), currentEnd.getUTCMonth());
        } else if (type === 'month') {
            updatedDate = toUtcMonthEnd(newDate.getUTCFullYear(), newDate.getUTCMonth());
        } else {
            return;
        }

        if (isMonthly) {
            setEndDate(updatedDate);
        } else {
            setEndYearDate(toUtcMonthEnd(newDate.getUTCFullYear(), 11));
        }
    };

    //for item edit
    function formatDate(input) {
        
        // Split the date and time parts
        const [datePart, timePart] = input.split(' ');

        // Extract day, month, year
        const [day, month, year] = datePart.split('/').map(Number);

        let utcMillis;

        if (timePart) {
            // Extract hours, minutes, seconds (all as numbers)
            const [h, m, s] = timePart.split(':').map(Number);
            // Build a UTC timestamp with time
            utcMillis = Date.UTC(year, month - 1, day, h, m, s, 0);
        } else {
            // Build a UTC timestamp at midnight
            utcMillis = Date.UTC(year, month - 1, day, 0, 0, 0, 0);
        }

        // Create the Date object in UTC
        const date = new Date(utcMillis);

        // ISO string without the trailing "Z" and with fixed millisecond part
        return `${date.toISOString().slice(0, 19)}.000`;
    }

    const rawItemToEditItem = (myItem) => {
        if (!myItem) return null;
        return {
            id: myItem["Id"],
            accountCodeId: myItem["AccountCodeId"],
            caseId: myItem["CaseId"],
            sortCodeId: myItem["SortCodeId"],
            description: myItem["Description"],
            reference: myItem["Reference"],
            amount: parseFloat(myItem["Amount"]),
            documentDate: formatDate(myItem["t-document-date"]),
            uploadDate: formatDate(myItem["t-upload-date"]),
            reportingMonthDate: formatDate(myItem["t-reporting-month"]),
            registrationMonthDate: formatDate(myItem["RegistrationMonthDate"]),
            creditAccount: myItem["CreditAccount"],
            debitAccount: myItem["DebitAccount"],
            documentUrl: myItem["DocumentUrl"],
            accountCodeName: myItem["AccountCodeName"],
            uploadNumber: myItem["UploadNumber"],
            vat: parseFloat(myItem["VAT"]),
            accountCaseId: myItem["AccountCaseId"],
            vatAmount: parseFloat(myItem["t-vat"]),
            netAmount: parseFloat(myItem["t-amount-no-vat"]),
            docType: myItem["t-type"]
        };
    };

    const sortCodeReportItemsForModal = useMemo(() => {
        return responseData.map((myItem) => rawItemToEditItem(myItem)).filter(Boolean);
    }, [responseData]);

    
    const handleEdit = (row) => {
        const rowIndex = nodes.findIndex((n) => n.key === row.key);
        if (rowIndex === -1) return;                    // nothing to edit

        const myItem = responseData[rowIndex];

        if (!myItem) return;

        setCurrentItem(rowIndex);
    };

    const setCurrentItem = (rowIndex) => {
        const myItem = responseData[rowIndex];
        if (!myItem) return;
        const item = rawItemToEditItem(myItem);
        if (!item) return;
        setCurrentIndex(rowIndex);
        setItemToDelete({ id: item.id, type: item.docType });
        setEditingRow(item.id);
        setEditedItem({ ...item });
        setEditedPopupItem(true);
        setStatusCheck(myItem['t-processed'] === 'מסמך טופל');
    };


    const handlePrevious = () => {
        if (currentIndex > 0) {
            const newIndex = currentIndex - 1;
            setCurrentItem(newIndex);
        }
    };

    const handleNext = () => {
        if (currentIndex < sortCodeReportItemsForModal.length - 1) {
            setCurrentItem(currentIndex + 1);
        }
    };



    // put these helpers at module scope (above the component)
    const DEFAULT_WIDTH = 120;
    const widthMap = {
        't-upload-date': 90,
        't-document-date': 90,
        't-debit-account': 120,
        't-credit-account': 120,
        't-details': 300,
        't-reference': 65,
        't-reference2': 65,
        't-amount-vat': 90,
        't-amount-no-vat': 90,
        't-vat': 90,
        't-processed': 80,
    };
    const isNumeric = (field) => /(amount|vat)$/i.test(field);

    /* -------------------------------------------------------------------------- */
    /* fetchSortCodeDetails (fixed)                                               */
    /* -------------------------------------------------------------------------- */
    const fetchSortCodeDetails = async (startDate, endDate) => {
        if (!selectedSortCodeId && !sortCodeName) {
            setNodes([]);
            setResponseData([]);
            setFooterTotals({});
            setColumns([]);
            setLoading(false);
            return;
        }

        const fetchGeneration = ++sortCodeFetchGenerationRef.current;
        setLoading(true);

        try {
            const rangeStart = toUtcMonthStart(
                startDate.getUTCFullYear(),
                startDate.getUTCMonth()
            );
            const rangeEnd = toUtcMonthEnd(
                endDate.getUTCFullYear(),
                endDate.getUTCMonth()
            );

            /* ───────────── resolve the sort code id ─────────────
               An explicit id (navigation state or the picker) is used as is; resolving by
               name is only a fallback and is ambiguous when names are duplicated. */
            let sortReturnedCodeId = selectedSortCodeId ? String(selectedSortCodeId) : '';

            if (!sortReturnedCodeId) {
                const metaRes = await EnumsService.GetSortCodeByName(
                    sortCodeName,
                    client.accountantId,
                    token,
                );
                if (fetchGeneration !== sortCodeFetchGenerationRef.current) return;
                if (!metaRes.ok) throw new Error(await metaRes.text());

                const meta = await metaRes.json();
                const isEquip = meta.sortCodeVatType === Constants.SortCodeVatTypeValue.VatEquipment;
                setIsPurchaseOfEquipment(isEquip);

                sortReturnedCodeId =
                    meta.sortCodeId === undefined || meta.sortCodeId === null
                        ? '-1'
                        : String(meta.sortCodeId);
            }

            if (fetchGeneration !== sortCodeFetchGenerationRef.current) return;
            setSortCodeId(sortReturnedCodeId);

            /* ───────────── get transactions ───────────── */
            const trxRes = await ClientService.SortCodeDetails(
                client.caseId,
                client.accountantId,
                rangeStart,
                rangeEnd,
                token,
                sortReturnedCodeId,
                isMonthly,
                segmentationFilter,
                filterByDocumentDate,
            );

            if (fetchGeneration !== sortCodeFetchGenerationRef.current) return;
            if (!trxRes.ok) throw new Error(await trxRes.text());

            /* raw API shape is { x: { y: { z: [ …transactions ]}}} */
            const api = await trxRes.json();
            if (fetchGeneration !== sortCodeFetchGenerationRef.current) return;

            const firstDict = api[Object.keys(api)[0]];
            const secondDict = firstDict[Object.keys(firstDict)[0]];
            const thirdDict = secondDict[Object.keys(secondDict)[0]];
            const values = thirdDict[Object.keys(thirdDict)[0]];
            const transactions = values || [];
                
            setResponseData(transactions);
            /* ───────────── build columns (w/ width & alignment) ───────────── */
            const rawColumns = [
                { field: 't-upload-date', header: t('RegistrationDate') },
                { field: 't-document-date', header: t('ValueDate') },
                { field: 't-debit-account', header: t('Debit Account') },
                { field: 't-credit-account', header: t('Credit Account') },
                { field: 't-details', header: t('Details') },
                { field: 't-reference', header: t('Reference 1') },
                { field: 't-reference2', header: t('Reference 2') },
                { field: 't-amount-no-vat', header: t('Including VAT') },
                { field: 't-amount-vat', header: t('Excluding VAT') },
                { field: 't-vat', header: t('VAT') },
                { field: 't-processed', header: '' },
            ];

            setColumns(
                rawColumns.map((c) => ({
                    ...c,
                    width: widthMap[c.field] ?? DEFAULT_WIDTH,
                    isNumeric: isNumeric(c.field),
                })),
            );

            /* ───────────── rows + footer totals ───────────── */
            const nodes = [];
            const footerTotals = {
                't-amount-vat': 0,
                't-amount-no-vat': 0,
                't-vat': 0,
            };

            transactions.forEach((trx) => {
                /* prettify “processed” flag */
                trx['t-processed'] = trx['t-processed'] === 'True'
                    ? t('DocumentProcessed')
                    : t('DocumentNotProcessed');

                /* parse raw numbers BEFORE beautifying */
                const rawVat = Number(String(trx['t-amount-vat'] || 0).replace(/,/g, ''));
                const rawNoVat = Number(String(trx['t-amount-no-vat'] || 0).replace(/,/g, ''));
                const rawVatVal = Number(String(trx['t-vat'] || 0).replace(/,/g, ''));
                
                footerTotals['t-amount-vat'] += rawVat;
                footerTotals['t-amount-no-vat'] += rawNoVat;
                footerTotals['t-vat'] += rawVatVal;
                
                /* DD/MM/YYYY hh:mm → DD/MM/YYYY */
                const formatDate = (s) => s.split(' ')[0];

                nodes.push({
                    key: trx['Id'],
                    data: {
                        't-upload-date': formatDate(trx['t-upload-date']),
                        't-document-date': formatDate(trx['t-document-date']),
                        't-debit-account': trx['t-debit-account'],
                        't-credit-account': trx['t-credit-account'],
                        't-details': trx['t-details'],
                        't-reference': trx['t-reference'],
                        't-reference2': trx['t-reference2'],
                        't-amount-vat': beautifyNumber(rawVat),
                        't-amount-no-vat': beautifyNumber(rawNoVat),
                        't-vat': beautifyNumber(rawVatVal),
                        't-processed': trx['t-processed'],
                    },
                });
            });

            if (fetchGeneration !== sortCodeFetchGenerationRef.current) return;
            setNodes(nodes);
            setFooterTotals(footerTotals);
            // toast.success(t('reportCardDataReturnedSuccessfully'));
        } catch (err) {
            if (fetchGeneration !== sortCodeFetchGenerationRef.current) return;
            console.error('fetchSortCodeDetails:', err);
            toast.error(`${t('errorFetchReportCardDataReturnedSuccessfully')}: ${err.message}`);
        } finally {
            if (fetchGeneration === sortCodeFetchGenerationRef.current) {
                setLoading(false);
            }
        }
    };






    const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
        <button className={`document-custom-input document-custom-input-range `} onClick={onClick} ref={ref}>
            {value}
        </button>
    ));



    const handleGoBack = () => {
        // Navigate back to the previous page using React Router
        if (client) {
            // navigate('/ProfitAndLossReport', { state: { type, client } });
            goBack()
        }
    };

    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            try {
                const currentUser = await UserService.getCurrentUser();
                const currentToken = await UserService.getCurrentToken();
                if (currentUser && currentToken) {
                    setUser(currentUser);
                    setToken(currentToken);

                    if (location.state && location.state.client && location.state.type &&
                        (location.state.sortCodeName || location.state.sortCodeId != null)) {
                        setType(location.state.type)
                        setClient(location.state.client);
                        setSortCodeName(location.state.sortCodeName ?? '');
                        setSelectedSortCodeId(
                            location.state.sortCodeId != null ? String(location.state.sortCodeId) : ''
                        );
                        await fetchEnums(currentUser, currentToken, location.state.client);
                    }
                    // Fetch financial data for the current date on initial load only
                }
                else {
                    navigate("/login");
                }

            } catch (error) {
                // Handle error - maybe navigate to login or show a message
            }
            setLoading(false);
        };


        fetchUserData();
    }, [location]);

    useEffect(() => {
        if (isDataFetched && !startDate && !endDate) {
            const startDate = getStartOfYear(new Date());
            const endDate = getCurrentMonth(new Date());
            setStartDate(startDate); // Set start of the current year
            setEndDate(endDate); // Set end of the current month
            setStartYearDate(startDate); // Set start of the current year
            setEndYearDate(endDate); // Set end of the current month

        }
    }, [isDataFetched, startDate, endDate]);


    useEffect(() => {
        // Don’t run until the essential data is available
        if (!client || !token || (!sortCodeName && !selectedSortCodeId)) return;

        const run = () => {
            if (isMonthly) {
                if (startDate && endDate) {
                    fetchSortCodeDetails(startDate, endDate);
                }
            } else {
                if (startYearDate && endYearDate) {
                    // const y1 = new Date(Date.UTC(startYearDate.getFullYear(), 0, 1));
                    // const y2 = new Date(Date.UTC(endYearDate.getFullYear(), 11, 31));
                    fetchSortCodeDetails(startYearDate, endYearDate);
                }
            }
        };

        run();
    }, [
        client,
        token,
        sortCodeName,
        selectedSortCodeId,
        isMonthly,
        startDate,
        endDate,
        startYearDate,
        endYearDate,
        filterByDocumentDate,
    ]);





    // const getHeader = () => {
    //     return (
    //         <div className="flex justify-content-start">
    //             <IconField iconPosition="right">
    //                 <InputIcon className="pi pi-search" />
    //                 <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder={t("GeneralSearch")} />
    //             </IconField>
    //         </div>
    //     );
    // };



    const refreshData = async () => {
        if (isMonthly) {
            let startYear = new Date(startYearDate).getFullYear();
            let endYear = new Date(endYearDate).getFullYear();

            if (!startYear || !endYear) {
                console.error('Invalid dates:', startYearDate, endYearDate);
                return;
            }
            let startOfYear = new Date(startYear, 0, 1); // January is 0
            let endOfYear = new Date(endYear, 11, 31); // December is 11
            await fetchSortCodeDetails(startOfYear, endOfYear);
        }
        else {

            await fetchSortCodeDetails(startDate, endDate);
        }
    }


    function formatDateString(dateStr) {
        // Split the input string to separate date and time
        const parts = dateStr.split(' ');
        const datePart = parts[0];
        let timePart = parts[1];

        // Ensure the time is two digits for hours, minutes, and seconds
        timePart = timePart.split(':').map((timeComponent) => timeComponent.padStart(2, '0')).join(':');

        // Create a new Date object using the corrected format
        const date = new Date(`${datePart}T${timePart}`);

        // Validate the date object to ensure it's correct
        if (isNaN(date.getTime())) {
            throw new Error('Invalid date format');
        }

        // Format the date to ISO string and manually adjust milliseconds and timezone
        return date.toISOString().replace(/\.\d{3}Z$/, '.471Z'); // Replace milliseconds and Z with .471Z
    }

    const downloadReport = async () => {
        setLoading(true);
        try {
            const localStartDate = !isMonthly ? startYearDate : startDate;
            const localEndDate = !isMonthly ? endYearDate : endDate;

            await ClientService.SortCodeDetailsReport(
                client.caseId,
                client.accountantId,
                localStartDate,
                localEndDate,
                sortCodeId,
                token,
                isMonthly,
                segmentationFilter,
                filterByDocumentDate,
            );

            toast.success(t("reportDownloadSuccess"));
        }
        catch (error) {
            console.error(error);
            toast.error(t("reportDownloadFailure"));

        }
        setLoading(false);
    }
    const paginatorLeft = <Button type="button" icon="pi pi-refresh" text onClick={refreshData} />;
    const paginatorRight = <Button type="button" icon="pi pi-download" text onClick={downloadReport} />;

    const valueTemplate = (node, column) => {
        // Access the value from the node data based on the column field
        let value = node.data[column.field];

        // Determine the color based on the value: green if positive, red if zero or negative
        let color = parseInt(value, 10) >= 0 ? 'green' : 'red';

        // Return a span element with the styled value
        return (
            <span style={{ color: color, fontWeight: 'bold' }}>
                {value !== null ? `${parseFloat(value).toFixed(2).toLocaleString()}₪` : '0.00₪'}
            </span>
        );
    }


    const handleDeleteClick = () => {
        setIsModalVisible(true);
    };

    const handleEditDeleteClick = (itemId) => {
        setEditedPopupItem(false);
        setEditedItem({});
        handleDeleteClick();
    };

    const handleConfirmDelete = async () => {
        // Perform delete operation
        setLoading(true);
        setIsModalVisible(false);
        try {
            const response = await DocumentService.DeleteDocument(itemToDelete.type, itemToDelete.id, token);
            if (response.ok) {
                await fetchSortCodeDetails(startDate, endDate);
                // Show success toast
                toast.success(t("documentDeleteSuccess"));
            } else {
                // Handle any errors or display an error toast
                const errorResponse = await response.json();
                console.error('Error deleting document:', errorResponse);

                // Show error toast
                toast.error(t("documentDeleteError"));
            }
        } catch (error) {
            console.error('Error deleting document:', error);

            // Show error toast
            toast.error(t("documentDeleteError"));
        }
        setLoading(false);
    };

    //mui searches:
    const [focused, setFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    // Memoized filtered and sorted nodes based on searchQuery and sortConfig
    const filteredAndSortedNodes = useMemo(() => {
        if (!nodes || nodes.length === 0) return [];

        const filteredData = nodes.filter((node) => {
            const query = searchQuery.toLowerCase();
            return (
                node.data.Description?.toLowerCase().includes(query) ||
                columns.some(col => node.data[col.field]?.toString().includes(query))
            );
        });

        if (sortConfig.key) {
            filteredData.sort((a, b) => {
                const aValue = a.data[sortConfig.key] || "";
                const bValue = b.data[sortConfig.key] || "";

                if (sortConfig.type === 'number') {
                    return sortConfig.direction === 'ascending'
                        ? parseFloat(aValue) - parseFloat(bValue)
                        : parseFloat(bValue) - parseFloat(aValue);
                } else if (sortConfig.type === 'date') {
                    return sortConfig.direction === 'ascending'
                        ? new Date(aValue) - new Date(bValue)
                        : new Date(bValue) - new Date(aValue);
                } else {
                    return sortConfig.direction === 'ascending'
                        ? aValue.localeCompare(bValue)
                        : bValue.localeCompare(aValue);
                }
            });
        }

        return filteredData;
    }, [nodes, searchQuery, sortConfig, columns]);


    const handleStartYearDate = async (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        

        // Persist the new start year date to localStorage
        localStorage.setItem('SortCodeReport-startYearDate', date);

        setStartYearDate(date);
    };

    const handleEndYearDate = async (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));

        // Persist the new end year date to localStorage
        localStorage.setItem('SortCodeReport-endYearDate', date);

        setEndYearDate(date);
    };


    const handleExpandRow = (key) => {
        setExpandedRows((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const handleNavigateToAssets = () => {
        navigate('/Assets', { state: { type, client } });
    };

    const buttonData = [
        {
            label: 'DownloadSortCodeReport',
            onClick: downloadReport,
            icon: () => <DownloadOutlinedIcon fontSize="small" />,
            style: { maxWidth: 200 },
        },
        ...(isPurchaseOfEquipment
            ? [{
                label: 'NavigateToAssets',
                onClick: handleNavigateToAssets,
                icon: () => <Inventory2OutlinedIcon fontSize="small" />,
            }]
            : []),
    ];

    return (
        <>
            {/* <HamburgerMenu client={client} /> */}


            <AssetFoundDialog
                open={showAssetFoundDialog}
                asset={foundAsset}
                assetGroups={assetGroups}
                onClose={() => setShowAssetFoundDialog(false)}
                isDraggable={true}            // or false if you don't want drag
                caseId={client?.caseId}
                token={token}
                transactionId={editedItem.id}
                fetchEnums={fetchEnumsNoParams}
            />

            <>
                <>
                    <Box
                        dir={direction}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                            flexWrap: 'wrap',
                            width: '100%',
                            mb: 1,
                        }}
                    >
                        <Box sx={{ minWidth: 220, maxWidth: 280, flex: '1 1 220px' }}>
                            <AutocompleteSelectFilter
                                options={sortCodePickerOptions}
                                selectedValues={selectedSortCodeOption}
                                onChange={(_, option) => handleSortCodePicked(option)}
                                label={t('Select SortCode')}
                                placeholder={t('Select SortCode')}
                                isMultiple={false}
                                direction={direction}
                                portalMenu
                                searchable
                            />
                        </Box>
                        <NavigationButton
                            t={t}
                            direction={direction}
                            data={buttonData}
                        />
                    </Box>
                    <div className={`searchFilter-bar__container document-toolbar-row ${direction}`} style={{ marginBottom: '10px' }}>
                        <Box className="document-filter-row" dir={direction}>
                            <TextField
                                size="small"
                                dir={direction}
                                placeholder={t('Search')}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="document-search-bar"
                                variant="standard"
                                InputProps={{
                                    disableUnderline: true,
                                    className: `custom-input-box-sizing ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon className="document-search-icon" />
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            <Box className="document-data-view">
                                <ToggleButtonGroup
                                    value={isMonthly ? 'monthly' : 'yearly'}
                                    exclusive
                                    onChange={(event, newValue) => {
                                        if (newValue !== null) {
                                            handleRangeChange(newValue === 'monthly');
                                        }
                                    }}
                                    size="small"
                                >
                                    <ToggleButton value="yearly" aria-label="yearly">
                                        {t('Yearly')}
                                    </ToggleButton>
                                    <ToggleButton value="monthly" aria-label="monthly">
                                        {t('Monthly')}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>

                            {isMonthly ? (
                                <div className={headerStyles.dateSelectRange}>
                                    <div className={headerStyles.dateSelect}>
                                        <FilterMonthYearPicker
                                            year={startDate}
                                            month={startDate}
                                            onYearChange={(newYear) => handleStartDateChangeNew(newYear, 'year')}
                                            onMonthChange={(newMonth) => handleStartDateChangeNew(newMonth, 'month')}
                                            labelYear={t('StartYear')}
                                            labelMonth={t('StartMonth')}
                                            direction={direction}
                                        />
                                    </div>
                                    <div className={headerStyles.rangeDivider} />
                                    <div className={headerStyles.dateSelect}>
                                        <FilterMonthYearPicker
                                            year={endDate}
                                            month={endDate}
                                            onYearChange={(newYear) => handleEndDateChangeNew(newYear, 'year')}
                                            onMonthChange={(newMonth) => handleEndDateChangeNew(newMonth, 'month')}
                                            labelYear={t('EndYear')}
                                            labelMonth={t('EndMonth')}
                                            direction={direction}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className={`${headerStyles.dateSelectRange} ${headerStyles.dateSelectRangeCompact}`}>
                                    <div className={headerStyles.dateSelectYear}>
                                        <FilterMonthYearPicker
                                            year={startYearDate}
                                            onYearChange={(date) => handleStartYearDate(date)}
                                            labelYear={t('StartDate')}
                                            direction={direction}
                                            yearOnly
                                        />
                                    </div>
                                    <div className={headerStyles.rangeDivider} />
                                    <div className={headerStyles.dateSelectYear}>
                                        <FilterMonthYearPicker
                                            year={endYearDate}
                                            onYearChange={(date) => handleEndYearDate(date)}
                                            labelYear={t('EndDate')}
                                            direction={direction}
                                            yearOnly
                                        />
                                    </div>
                                </div>
                            )}
                        </Box>

                        <Box className="document-mode-toggles">
                            <Box className={`document-mode-toggle${!filterByDocumentDate ? ' is-checked' : ''}`}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={!filterByDocumentDate}
                                            onChange={() => setFilterByDocumentDate(false)}
                                            size="small"
                                            inputProps={{ 'aria-label': t('FilterByRegisterMonthDate') }}
                                        />
                                    }
                                    label={t('FilterByRegisterMonthDate')}
                                />
                            </Box>
                            <Box className={`document-mode-toggle${filterByDocumentDate ? ' is-checked' : ''}`}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={!!filterByDocumentDate}
                                            onChange={() => setFilterByDocumentDate(true)}
                                            size="small"
                                            inputProps={{ 'aria-label': t('FilterByDocumentDate') }}
                                        />
                                    }
                                    label={t('FilterByDocumentDate')}
                                />
                            </Box>
                        </Box>
                    </div>

                    <SortCodeReportTable
                        filteredAndSortedNodes={filteredAndSortedNodes}
                        columns={columns}
                        handleEdit={handleEdit}
                        footerTotals={footerTotals}
                        sortConfig={sortConfig}
                        onSortChange={handleSortChange}
                    />
                </>
                <ToastContainer position={direction === 'rtl' ? 'top-left' : 'top-right'} rtl={direction === 'rtl'} />
                {loading && (
                    <div className="loader-container">
                        <PuffLoader
                            size={100}        // Larger size for better visibility
                            loading={loading}
                        />
                    </div>
                )}

                <CustomDeleteConfirmationModal
                    isVisible={isModalVisible}
                    onClose={() => setIsModalVisible(false)}
                    onDelete={handleConfirmDelete}
                    confirmMessage={t('confirmDeleteMessage')}
                    titleMessage={t('confirmDeleteTitle')}
                />

                {showChooseAsset && (
                    <ChooseAsset
                        date={dateForAsset}
                        open={showChooseAsset}
                        onClose={() => handleAssetClose()}
                        type={editedItem?.docType}
                        itemId={itemToAddToAsset}
                        client={client}
                        token={token}
                        editedItemVat={editedItem.vat}
                        onAssetChosen={(assetId) => {
                            setShowChooseAsset(false);
                        }}
                        onCreateAsset={(newAsset) => {
                            setShowChooseAsset(false);
                        }}
                        fullItem={itemForAssets}
                        saleEquipment={saleEquipment}
                        clickedAsset={clickedAsset}
                        fetchEnums={fetchEnums}
                        user={user}
                        setShowAddGroupModal={handleOpenGroudAdd}
                        assetGroups={assetGroups}

                    />
                )}

                {showAddGroupModal && (
                    <AddAssetGroup
                        open={showAddGroupModal}
                        onClose={() => setShowAddGroupModal(false)}
                        caseId={client.caseId}
                        token={token}
                        assetGroups={assetGroups}
                        refreshAssetGroups={() => {
                            // Refresh the list
                            fetchEnums(user, token, client);
                            setShowAddGroupModal(false);
                        }}
                    />
                )}




                {editedItem && editedPopupItem && Object.keys(editedItem).length > 0 && (

                    <EditModal
                        editedItem={editedItem}
                        fade={fade}
                        handlePrevious={handlePrevious}
                        handleNext={handleNext}
                        currentIndex={currentIndex}
                        filteredAndSortedData={sortCodeReportItemsForModal}
                        NoDocumentsPdf={NoDocumentsPdf}
                        t={t}
                        handleAccountChange={handleAccountChange}
                        isRange={isRange}
                        isClosedReportingMonth={isClosedReportingMonth}
                        accountCardOptions={accountCardOptions}
                        handleChange={handleChange}
                        handleDateChange={handleDateChange}
                        CustomInput2={CustomInput2}
                        setReportingMonthDate={setReportingMonthDate}
                        handleVatRadioChange={handleVatRadioChange}
                        statusCheck={statusCheck}
                        handleRadioChange={handleRadioChange}
                        type={type}
                        editedAddAccountCard={editedAddAccountCard}
                        handleCloseEditAddNewAccountCardDocument={handleCloseEditAddNewAccountCardDocument}
                        handleEditAddAccountChange={handleEditAddAccountChange}
                        sortCodeIdOptions={sortCodeIdOptions}
                        debitAccountOptions={debitAccountOptions}
                        creditAccountOptions={creditAccountOptions}
                        handleUpdate={handleUpdate}
                        handleCancel={handleCancel}
                        handleDeleteClick={handleEditDeleteClick}
                        client={client}
                        token={token}
                        setAccountCardOptions={setAccountCardOptions}
                        setLoading={setLoading}
                        setEditedAddAccountCard={setEditedAddAccountCard}
                        setEditedItem={setEditedItem}
                        handleReopenEdit={handleReopenEdit}
                        palCodes={formattedPalCodeOptions}
                        fetchEnums={fetchEnums}
                        RefreshPage={refreshData}
                        assets={assets}
                        assetClicked={handleAssetClicked}

                    />
                )}

            </>

        </>
    );
}

export default SortCodeReport;